/**
 * ユーザ(社員)
 */
import React from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Button,
    Grid,
    DialogTitle
} from '@material-ui/core';
import CustomizedSearchInput from 'mdoc/utils/CustomizedSearchInput';
import { dictionary } from 'mdoc/admin/axios'
import * as config from 'mdoc/admin/axios/config'
import { getClient } from 'mdoc/admin/axios/client'
import CustomizedTable from 'mdoc/utils/table'
import { ByteFormatToGB } from 'mdoc/utils';
import { updateStatusClient } from 'mdoc/admin/axios/client'
import Toast from 'mdoc/utils/toast';
import Dialog from 'mdoc/utils/myDialog';

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    link: {
        color: '#2196f3'
    },
    margin: {
        margin: theme.spacing.unit
    },
    title: {
        marginLeft: '-20px'
    }
});
class Client extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        loading: false,
        pagination: {
            pageNumber: 1,
            pageSize: 25,
            count: 0,
            sidx: '',
            sord: ''
        },
        dictWord: {
            'client': '',
            'status': '',
            'company_name': '',
            'capacity': '',
            'service_start_date': '',
            'service_end_date': '',
            'client_login': '',
            'management': '',
            'modify_record': '',
            'delete_record': '',
            'stop_record': '',
            'restart': '',
            'start_before': '',
            'in_use': '',
            'stopping': '',
            'exit': '',
            'yes': '',
            'cancel': '',
            'confirmation': '',
            'msg_confirm_really_delete': '',
            'msg_confirm_really_restart': '',
            'msg_confirm_really_stop': '',
            'msg_error_record_not_found': '',
            'group_id':''
        },
        status: config['CLIENT_STATUS'],
        search: '',
        id: '',
        clientCode: '',
        dialogOpen: false,
        dialogMessage: '',
        statusOption: ''

    }
    componentWillMount() {
        this.start();
    }
    start = () => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(this.state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
    }


    fetch = (params = {}) => {
        this.setState({ loading: true })
        getClient({
            ...params,
        }).then((data) => {
            const pagination = { ...this.state.pagination, ...params }
            pagination.count = data.count;
            if (data.results === undefined) {
                Toast.info(this.state.dictWord.msg_error_record_not_found)
            }
            this.setState({
                loading: false,
                data: data.results !== undefined ? data.results : [],
                pagination: pagination,
            })
        }).catch(error => {
            Toast.info(error)
        })
    }


    handleTableChange = (event, pagination) => {
        this.fetch({
            name: this.state.search,
            pageNumber: pagination.page,
            pageSize: pagination.rowsPerPage,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    }
    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';

        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            name: this.state.search,
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })


    };

    statusOpt = (id, status) => event => {
        this.setState({
            id: id,
            statusOption: status,
            dialogOpen: true,
            dialogMessage: status === 1 ? this.state.dictWord['msg_confirm_really_stop'] :
                status === 2 ? this.state.dictWord['msg_confirm_really_restart'] : this.state.dictWord['msg_confirm_really_delete']
        });
    }
    dialogHandleOK = (event) => {
        updateStatusClient({
            id: this.state.id,
            status: this.state.statusOption
        }).then(res => {
            window.location.reload()
        }).catch(function (error) {
            Toast.error(error);
        })
    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }
    handleSearch(keyWords) {
        this.setState({
            search:keyWords
        },()=>{
            this.fetch({
                name: this.state.search,
                pageNumber: this.state.pagination.pageNumber,
                pageSize: this.state.pagination.pageSize,
                sidx: this.state.pagination.sidx,
                sord: this.state.pagination.sord,
            })
        });
    }
    handleChange = event => {
        this.setState({
            search: event.target.value
        });
    };

    render() {
        const { classes } = this.props;
        const columns = [
            {
                title: this.state.dictWord.status,
                dataIndex: 'status',
                sorter: true,
                render: text => this.state.dictWord[this.state.status[text]]
            },
            {
                title: this.state.dictWord.group_id,
                dataIndex: 'clientCode',
                sorter: true,
                width: '209px',
                render: (text, record) => <Link to={{ pathname: '/admin/management/client_detail/' + record.id, state: { id: record.id } }} className={classes.link}>{text}</Link>,
            },
            {
                title: this.state.dictWord.company_name,
                dataIndex: 'name',
                width: '209px',
            },
            {
                title: this.state.dictWord.capacity,
                dataIndex: 'capacity',
                render: (text) => ByteFormatToGB(text)
            },
            {
                title: this.state.dictWord.service_start_date,
                dataIndex: 'startTimeStr',
                sortIndex: 'serviceStartTime',
                sorter: true,
            },
            {
                title: this.state.dictWord.service_end_date,
                dataIndex: 'endTimeStr',
                sortIndex: 'serviceEndTime',
                sorter: true,
            },
            {
                title: this.state.dictWord.management,
                key: 'action',
                toolTipDisabled: true,
                width: '188px',
                render: (text, record, rowId) => {
                    let opt = <Button variant="contained" color="primary" onClick={this.statusOpt(record.id, record.status)} className={classes.margin}>{this.state.dictWord.delete_record}</Button>;
                    if (record['status'] === 1) {
                        opt = <Button variant="contained" color="primary" onClick={this.statusOpt(record.id, record.status)} className={classes.margin}>{this.state.dictWord.stop_record}</Button>;
                    }
                    if (record['status'] === 2) {
                        opt = <Button variant="contained" color="primary" onClick={this.statusOpt(record.id, record.status)} className={classes.margin}>{this.state.dictWord.restart}</Button>;
                    }
                    return <span>
                        <Button variant="contained" color="primary" href={'/admin.html#/admin/management/client_detail/' + record.id}>{this.state.dictWord.modify_record}</Button>
                        {record['status'] === 0 ? null : opt}
                    </span>
                }

            }
        ]
        return (
            <div className="mainDom" style={{ minWidth: '700px' }}>
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="space-between" alignItems="center" >
                    <Grid item xs={12} md={8}>
                        <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/management/client_detail'}>
                            {this.state.dictWord.client_login}
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CustomizedSearchInput onClick={this.handleSearch.bind(this)} />
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        page={this.state.pagination.pageNumber}
                        rowsPerPage={this.state.pagination.pageSize}
                        onChange={this.handleTableChange}
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dialogMessage}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

Client.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Client);
